import { useSearchParams } from "react-router";
import { useGlobals } from "./useGlobals";

export const useReturnUrl = () => {
  const { fields } = useGlobals() || {};
  const [searchParams] = useSearchParams();

  const returnUrl = fields?.find((field) => field.field === "returnUrl")?.value;

  if (returnUrl) {
    return encodeURIComponent(returnUrl);
  }

  const queryReturnUrl = searchParams.get("returnUrl");

  if (!queryReturnUrl) {
    return null;
  }

  return encodeURIComponent(queryReturnUrl);
};
